export const handleLevel4IndexClick = async (
  breadcrumb_info: any,
  siteInfo: any,
  navigate: any
) => {
  if (breadcrumb_info[3].id !== Number(localStorage.clickedId)) {
    localStorage.setItem("sitesTablePage", "0");
  }
  localStorage.setItem(
    "storedSelectedIndex",
    JSON.stringify({
      level1: "",
      level2: "",
      level3: "",
      level4: "",
      level5: "",
      level6: "",
    })
  );

  localStorage.setItem("siteAboutScrollTop", "0");
  localStorage.setItem("expandedObjectSaved", "false");
  localStorage.setItem("navigatedFromSitesAboutPage", "true");
  localStorage.setItem("clickedId", JSON.stringify(breadcrumb_info[3].id));
  localStorage.setItem("level1Id", JSON.stringify(breadcrumb_info[0].id));
  localStorage.setItem("level2Id", JSON.stringify(breadcrumb_info[1].id));
  localStorage.setItem("level3Id", JSON.stringify(breadcrumb_info[2].id));
  localStorage.setItem("level4Id", JSON.stringify(breadcrumb_info[3].id));
  localStorage.setItem("level4Click", "true");
  siteInfo?.integration_type_name === "autopatrol"
    ? navigate("/sites_patrol")
    : navigate("/sites");
};
